import { rightArrowIcon } from '../../../constants/icons';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function Reminders({ defaultImg, imgSrc, reminderTime, reminderDate, description, viewDetailsLink, type }) {

  const navigate = useNavigate();
  const isExternalLink = (url) => {
    try {
        const link = new URL(url);
        return link.protocol === "http:" || link.protocol === "https:";
    } catch (e) {
        return false;
    }
  };

  const clickHandler = () => {
    if (viewDetailsLink) {
      if (isExternalLink(viewDetailsLink)) {
          if (type === 'Deadlines') { 
            window.location.replace(viewDetailsLink);
            return;
          }
          window.open(viewDetailsLink, '_blank');
      } else {
          navigate(viewDetailsLink);
      }
    }
  };

  return (
    <div className="reminders-content">
      <div className="img-wrap">
        <Link onClick={clickHandler}>
        <img
          loading="lazy"
          src={imgSrc}
          onError={(e) => (e.target.src = defaultImg)}
          alt="Reminder"
        />
        </Link>
      </div>
      <div className="info-wrap">
        <div className="myk__event-time-wrapper">
          {reminderTime && <span className="myk__event-time">{reminderTime}</span>}
          {reminderDate && <span className="myk__event-month">{reminderDate}</span>}
        </div>
        <Link onClick={clickHandler}>
          <p>{description}</p>
        </Link>
        <Link
          className="view-details"
          onClick={clickHandler}
        >
          View details {rightArrowIcon}
        </Link>
      </div>
    </div>
  );
}
